import type { PlanState } from '@aline/common';
import { hasVisibleNodeOutput } from '@aline/common';
import { Apollo } from 'src/gql/generated';

export function getHasVisibleHarnessWork(planState: PlanState) {
  return hasVisibleNodeOutput(planState.nodeOutputs);
}

export function getIsTerminalAssistantStatus(status: Apollo.AgentMessageStatus) {
  return (
    status === Apollo.AgentMessageStatus.Complete ||
    status === Apollo.AgentMessageStatus.Error ||
    status === Apollo.AgentMessageStatus.Cancelled
  );
}
